<app-common-table #child [params]="getTableParams()"></app-common-table>
